var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 15a5.997 5.997 0 0 0 5.91-5h11.676l-1.293 1.293 1.414 1.414L30.414 9l-3.707-3.707-1.414 1.414L26.586 8H14.91A5.997 5.997 0 0 0 3 9a6 6 0 0 0 6 6zM49.5 8h-6.59A5.997 5.997 0 0 0 31 9a5.997 5.997 0 0 0 11.91 1h6.59C55.29 10 60 14.71 60 20.5S55.29 31 49.5 31H33.414l1.293-1.293-1.414-1.414L29.586 32l3.707 3.707 1.414-1.414L33.414 33H49.5C56.393 33 62 27.393 62 20.5S56.393 8 49.5 8z",
    fill: "#442418",
    opacity: 1,
    "data-original": "#442418",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 6,
    fill: "green",
    opacity: 1,
    "data-original": "green",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 49a6 6 0 1 0 0 12 5.997 5.997 0 0 0 5.91-5h11.676l-1.293 1.293 1.414 1.414L48.414 55l-3.707-3.707-1.414 1.414L44.586 54H32.91A5.997 5.997 0 0 0 27 49z",
    fill: "#442418",
    opacity: 1,
    "data-original": "#442418",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 56h2.086l-1.293 1.293 1.414 1.414L20.414 55l-3.707-3.707-1.414 1.414L16.586 54H14.5C8.71 54 4 49.29 4 43.5S8.71 33 14.5 33h2.59A5.997 5.997 0 0 0 29 32a5.997 5.997 0 0 0-11.91-1H14.5C7.607 31 2 36.607 2 43.5S7.607 56 14.5 56z",
    fill: "#442418",
    opacity: 1,
    "data-original": "#442418",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.e06fd5f731ce1b0a9f613f9273963554.svg";
export { ForwardRef as ReactComponent };